import React, { useState } from 'react';
import { Box, Button, Divider, IconButton, MenuItem, Paper, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModalCredits = (props) => {
  const purchaseOptions = [
    { value: 5, price: 10, link: "https://xg205.infusionsoft.com/app/manageCart/addProduct?productId=557" },
    { value: 10, price: 20, link: "https://xg205.infusionsoft.app/app/manageCart/addProduct?productId=559" },
    { value: 20, price: 40, link: "https://xg205.infusionsoft.app/app/manageCart/addProduct?productId=563" },
    { value: 30, price: 60, link: "https://xg205.infusionsoft.app/app/manageCart/addProduct?productId=565" },
    { value: 60, price: 120, link: "https://xg205.infusionsoft.app/app/manageCart/addProduct?productId=567" }
  ];

  const [selectedPurchaseOption, setSelectedPurchaseOption] = useState(purchaseOptions[1]);

  const handleCreditsChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = purchaseOptions.find(option => option.value === selectedValue);
    setSelectedPurchaseOption(selectedOption);
  };

  return (
    <Paper
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: 'translate(-50%, -50%)',
        boxShadow: 24,
        p: 2,
      }}
    >
      <Box sx={{alignItems: "center", display: "flex",}}>
        <Typography component="h2" fontSize={22} fontWeight={400} variant="h5" sx={{flex: 1,}}>Credits</Typography>
        <IconButton onClick={props.handleModalCreditsClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography fontSize={18}>How Many Credits Do You Need?</Typography>
        <Box sx={{ my: 1 }}>
          <Typography fontSize={13} textAlign="center">Each rendered image costs 1 credit.</Typography>
          <Typography fontSize={13} textAlign="center">Creating a project from photos costs 15 credits.</Typography>
          <Typography fontSize={13} textAlign="center">Terms and conditions apply.</Typography>
        </Box>
        <Typography fontSize={13} fontStyle="italic" textAlign="center">*On the checkout page, please use the same e-mail as your Personal Architect account.</Typography>
        <TextField
          fullWidth
          label="Credits"
          select
          value={selectedPurchaseOption.value}
          onChange={handleCreditsChange}
          sx={{ mt: 2 }}
        >
          {purchaseOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.value + " Credits"}
            </MenuItem>
          ))}
        </TextField>
        <Box sx={{ alignItems: "center", backgroundColor: "#efefef", display: "flex", height: 40, justifyContent: "center", my: 1, width: "100%" }}>
          <Typography fontWeight={600}>
            Total Price:
          </Typography>
          <Typography color="primary" sx={{ml:.5,}}>
            {"$" + selectedPurchaseOption.price.toFixed(2) + " USD"}
          </Typography>
        </Box>
        <Button fullWidth href={selectedPurchaseOption.link} target="_blank" variant="contained">Checkout</Button>
      </Box>
    </Paper>
  );
};

export default ModalCredits;
